import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuildInfoService {
  constructor(private http: HttpClient) {}

  getBuildInfo(): Observable<any> {
    return this.http.get(`${environment.assetsEndPoint}/assets/config/environment.json`).pipe(
      switchMap((config: any) => {
        const status = config.env;
        const baseUrl = config.baseUrl || environment.baseUrl;
        return this.http.get(`${baseUrl}/aum/public/v1/release/info?env=${status}`);
      })
    );
  }
}
